import { render, staticRenderFns } from "./PersonalityAssessment.vue?vue&type=template&id=48bc709a&scoped=true&"
import script from "./PersonalityAssessment.vue?vue&type=script&lang=js&"
export * from "./PersonalityAssessment.vue?vue&type=script&lang=js&"
import style0 from "./PersonalityAssessment.vue?vue&type=style&index=0&id=48bc709a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bc709a",
  null
  
)

export default component.exports